import { render, staticRenderFns } from "./ZohoDeskTicketsTable.vue?vue&type=template&id=39387d24"
import script from "./ZohoDeskTicketsTable.vue?vue&type=script&lang=js"
export * from "./ZohoDeskTicketsTable.vue?vue&type=script&lang=js"
import style0 from "./ZohoDeskTicketsTable.vue?vue&type=style&index=0&id=39387d24&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports